<template>
    <div>
        <form autocomplete="no" @submit.prevent="sign">
            <fieldset :disabled="loading" aria-autocomplete="no">
                <div v-if="InitData == null" class="checking">
                    Denetleniyor...
                </div>
                <div v-else-if="InitData.Code === 0">
                    <div v-if="SelectedCert == null">
                        <button type="button" @click="refreshTerminalsAndCertificates(false)" class="btn btn-info btn-sm float-right" title="Listeyi yenile">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-repeat" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                            <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                            </svg>
                        </button>
                        <p>Lütfen sertifikayı seçin.</p>
                        <div class="cert-list form-control">
                            <div v-if="!Terminals || Terminals.length == 0" class="text-center text-muted" style="padding:30px">
                                <p>Bilgisayarınıza bağlı e-imza cihazı bulunamadı.</p>
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="refreshTerminalsAndCertificates">Yeniden dene</button>
                            </div>
                            <div v-for="t in Terminals" v-bind:key="t.Index">
                                <div class="terminal"><b>[{{t.Index}}] {{t.Name}}</b> {{t.LibName}}</div>
                                <certificate-item :cert="c" v-on:click="selectCert(c)" v-for="c in t.SignatureCertificates" :key="c.CertificateSerialNumber" />
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <slot></slot>
                        
                        <certificate-item :cert="SelectedCert" v-if="!loading" @click="SelectedCert = null; refreshTerminalsAndCertificates(false)" title="Farklı bir sertifika seçmek için tıklayın."/>
                        <certificate-item :cert="SelectedCert" v-else style="cursor:default;"/>
                        <!-- <div><a href="#" @click="SelectedCert = null">Farklı bir sertifika seç</a></div> -->

                        <div class="form-group">
                            <label>E-İmza Şifresi</label>
                            <input v-model="PIN" id="pin" ref="pin" :name="autoCompleteId" @focus="passwordInputType='password'" :type="passwordInputType" :autocomplete="autoCompleteId" class="form-control" required />
                        </div>
                        
                        <div class="item-list" v-if="showFileList">
                            <table class="table table-borderless table-hover">
                                <tbody>
                                    <tr v-for="i in items" :key="i.Id">
                                        <td>
                                            {{i.FileName}} <small class="text-muted">{{i.Size | prettyBytes}}</small>
                                            <div v-if="!i.OK && i.ModelState" class="text-muted" style="font-size:0.7rem;">
                                                <div v-for="errList in i.ModelState" :key="errList">
                                                    <div v-for="e in errList" :key="e">{{e}}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width:150px;">
                                            <div v-if="i.State == signStatus.prepearing">
                                                <spinner sr="Hazırlanıyor..." />
                                                Hazırlanıyor
                                            </div>
                                            <div v-else-if="i.State == signStatus.signing">
                                                <spinner sr="İmzalanıyor..." />
                                                İmzalanıyor
                                            </div>
                                            <div v-else-if="i.State == signStatus.sending">
                                                <spinner sr="Gönderiliyor..." />
                                                Gönderiliyor
                                            </div>
                                            <div v-else-if="i.State == signStatus.completed">
                                                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-success bi bi-check" viewBox="0 0 16 16">
                                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                                                </svg> -->
                                                <icon-check class="text-success"/>
                                                Tamamlandı
                                            </div>
                                            <div v-else-if="i.State == signStatus.canceled">
                                                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-warning bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                                </svg> -->
                                                <icon-exclamation-triangle class="text-warning" />
                                                İptal edildi
                                            </div>
                                            <div v-else-if="i.State == signStatus.error">
                                                <icon-exclamation-octagon class="text-danger" />
                                                Hata
                                            </div>
                                            <div v-else>{{i.State}}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div v-if="eSignAgreement">
                            <p>Devam etmeniz halinde aşağıdaki metin tarafınızdan imzalanacaktır.</p>                              
                            <div class="alert alert-primary" role="alert">
                                <h4 class="alert-heading d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi flex-shrink-0 mr-2" viewBox="0 0 16 16" role="img" aria-label="Info:">
                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                    </svg>
                                    {{eSignAgreement.SigningFileName}}
                                </h4>
                                <hr>
                                <div>
                                    {{eSignAgreement.SigningText}}
                                </div>
                            </div>
                        </div>                                                 
                        
                        
                        <div class="text-danger" v-show="this.error">{{this.error}}</div>
                        <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                            <spinner/>
                            {{processingMessage}}
                        </div>
                    </div>
                </div>
                <div v-else class="text-center" style="padding-top:30px;">
                    <div style="padding:30px 0px;">İmzalayıcı uygulaması bilgisayarınızda bulunamadı!</div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="check">Yeniden Dene</button>
                        <a class="btn btn-link" href="https://www.izometri.com.tr/imzalayici/imzalayiciSetup.exe" target="_blank">Şimdi Yükle</a>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
import CertificateItem from '@/components/CertificateItem.vue'
import spinner from '@/components/Spinner.vue'
import iconCheck from '@/components/Icons/check.svg'
import iconExclamationOctagon from '@/components/Icons/exclamation-octagon.svg'
import iconExclamationTriangle from '@/components/Icons/exclamation-triangle.svg'

const signStatus = {
    prepearing: 'prepearing',
    signing: 'signing',
    sending: 'sending',
    completed: 'completed',
    canceled: 'canceled',
    error: 'error'
};


export default {
    name: 'Imzalayici',
    props: {
        items: Array,   // İmzalanacak dosyalar
        identityNumber: String,  // İmzalayacak kişinin sertifikadaki kimlik numarası
        processingMessage: null, // İşlem yapılıyor, lütfen bekleyin mesajı. Dosyaların imzalanması tamamlandıktan sonra sunucuya gönderilirken gösterilmek üzere...
        showFileList: {
            default: true,
            type: Boolean
        },
        userCertificateUrl: {
            type: String,
            default: '/user/setUserCertificate'
        },
        eSignAgreement : Object
    },
    components: {
        CertificateItem,
        spinner,
        iconCheck,
        iconExclamationOctagon,
        iconExclamationTriangle
    },
    computed: {
        autoCompleteId(){
            return "off_" + Math.random().toString().replace('.', '');
        }
    },
    created() {
        this.licence = window.settings.licence;// process.env.VUE_APP_IMZALAYICI_LICENCE;
        this.check();
    },
    data() {
        return {
            signStatus: signStatus,
            InitData: null,
            Terminals: null,
            SelectedCert : null,
            PIN: null,
            passwordInputType : "text",
            base64certificate: null,
            loading: false,
            canceled: false,
            error: null,
            currentDocumentIndex: 0,    // Şu anda imzalanan doküman index numarası
            licence: null // 'mqv3r4B5wf4K66iNYwCcxszUwXOyc/MTWTGVOo4WoWa5qqyK1BCKAe8Iwf6P2EvyALHCmrTl1QM7bMEjI2sjXQ=='
        };
    },
    watch: {
        SelectedCert: function(val){
            if(val) {
                this.$emit('modechange', 'sign');
            } else {
                this.$emit('modechange', 'selectcert');
            }
        }
    },
    methods: {
        setLoading(isLoading){
            this.loading = isLoading;
            this.$emit('onloading', isLoading);
        },
        cancel(){
            this.canceled = true;
            this.setLoading(false);
        },
        check () {  // İmzalayıcı yüklü ve çalışıyor mu, kontrol et
            this.setLoading(true);
            var formData = new FormData();
            formData.set('licence', this.licence);
            
            return axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
            .then(r => {
                this.InitData = r.data;
                this.refreshTerminalsAndCertificates(true);
                })
            .catch(e => { 
                this.InitData = { Code: -1 };
                console.log(e);
                this.setLoading(false);
            })
        },
        refreshTerminalsAndCertificates(autoSelect = false){  // e-İmza terminalleri ve sertifikaları çek
            this.setLoading(true);
            
            var formData = new FormData();
            formData.set('licence', this.licence);

            axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/terminalsandcertificates`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
            .then(r => {
                this.Terminals = r.data.Terminals;
                //var certList = this.Terminals.flatmap(a => a.SignatureCertificates).filter(x => !x.IsExpired);
                var certList = this.Terminals.map(x => x.SignatureCertificates).reduce((a, b) => a.concat(b)).filter(x => !x.IsExpired);

                if(this.identityNumber)
                    certList = certList.filter(x => x.Serial == this.identityNumber);

                if(certList.length == 1 && autoSelect)
                    this.selectCert(certList[0]);
                else
                    this.setLoading(false);
            })
            .catch(e => { 
                this.Terminals = null;
                console.log(e);
                this.setLoading(false);
            });
        },
        sendCert(base64cert) {    // Sertifikayı sunucuya post et

            return axios.post(this.userCertificateUrl, { Base64Certificate: base64cert })
                .then(response => {                    
                    if(!response.data.Success) {
                        console.log(response);
                        this.base64certificate = null;
                        this.SelectedCert = null;
                        alert('İmza sertifikası gönderilemedi: ' + response.data.ErrorMessages);
                    }
                })
                .catch(response => {
                    //handle error
                    this.base64certificate = null;
                    this.SelectedCert = null;
                    console.log(response);
                    alert('İmza sertifikası gönderilemedi.');
                })
                .then(() => {
                    this.setLoading(false);
                });
        },
        selectCert(cert) {  // Sertifika seç
            this.PIN = null;
            this.setLoading(true);

            if(this.identityNumber && cert.Serial != this.identityNumber) {
                alert('Seçtiğiniz sertifika oturumu açık kullanıcıya ait değil.');
                return;
            }

            var formData = new FormData();
            formData.set('terminal', cert.SlotId);
            formData.set('certificateNumber', cert.CertificateSerialNumber);
            formData.set('responseType', 'json');
            formData.set('licence', this.licence);

            return axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/x509certificate`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
                .then(response => {                    
                    if(response.data.Code == 0) {
                        this.base64certificate = response.data.Data;
                        this.SelectedCert = cert;
                        this.sendCert(this.base64certificate);
                    } else {
                        console.log(response);
                        this.base64certificate = null;
                        this.SelectedCert = null;
                        this.setLoading(false);
                        alert('İmza sertifikası alınamadı.');
                    }
                })
                .catch(response => {
                    //handle error
                    this.base64certificate = null;
                    console.log(response);
                    alert('İmza sertifikası alınamadı.');
                    this.setLoading(false);
                });
        },
        signAtToken(item){ // Token üzerinde imzalama yap
            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = 'İşlem iptal edildi.';
                this.setLoading(false);
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                return;
            }


            item.State = signStatus.signing;
            this.$forceUpdate();

            var formData = new FormData();
            formData.set('terminal', this.SelectedCert.SlotId);
            formData.set('certificateNumber', this.SelectedCert.CertificateSerialNumber);
            formData.set('password', this.PIN);
            formData.set('responseType', 'Json');
            //formData.set('isContentBase64', true);
            //formData.set('content', item.ContentForSign);
            formData.set('licence', this.licence);

            if(item.SigningFunction == 'cades/signdigest') {
                formData.set('digest', item.ContentForSign);
                formData.append("includeContent", false);
            } else {
                formData.set('content', item.ContentForSign);
                formData.set('isContentBase64', true);

                if(item.SigningFunction != 'mime/signmime')
                formData.append("includeContent", true);
            }

            return axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/${item.SigningFunction}`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
                .then(response => {
                    console.log('SignResponse: ', response);

                    var signedValue = item.SigningFunction == 'mime/signmime' ? response.data : (response.data.signatureValue || response.data.Data)

                    this.postDocument(item, signedValue); // İmzalı dosyayı sunucuya yükle

                    var doc = this.items[++this.currentDocumentIndex];  // Sonraki imzalanacak dosyayı al

                    if(doc)
                    {
                        if(this.canceled)
                            return;

                        this.signDocument(doc); // Sonraki dosya için imzalamayı başlat
                    }

                    console.log('İmzalama başarılı: ', response);
                })
                .catch(response => {
                    //handle error
                    item.OK = false;
                    item.State = signStatus.error;
                    this.signing = false;
                    this.error = item.FileName + ' isimli dosya imzalanamadı:\r\n' + response.response.data.Message;
                    this.$emit('onerror', this.error);
                    this.setLoading(false);
                    this.$forceUpdate();
                    //console.log('İmzalama başarısız: ', response);
                });
        },
        postDocument(item, data) {  // İmzalı dosyayı sunucuya gönder
            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = 'İşlem iptal edildi.';
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                return;
            }

            if(this.error)
                return;

            if(!item.PostUrl) {
                item.SignedContent  = data;
                item.OK = true;
                 item.State = signStatus.completed;
                this.setLoading(false);
                this.$forceUpdate();

                if(this.items.filter(i => !i.OK).length == 0) {
                    this.$emit('completed', this.items);
                }
            } else {
                item.State = signStatus.sending;
                this.$forceUpdate();

                var params = item.PostParams;
                params.SignedContentBase64 = data;
                params.CertificateBase64 = this.base64certificate;
                params.SigningTime = item.SigningTime;
                params.TransactionId = item.TransactionId;

                axios.post(item.PostUrl, params).then(x => {
                    if(x.data.Success) {
                        item.OK = true;
                        item.State = signStatus.completed;

                        if(this.items.filter(i => !i.OK).length == 0) {
                            this.$emit('completed', this.items);
                        }
                    } else {
                        item.OK = false;
                        item.State = signStatus.error;
                        this.setLoading(false);
                        this.error = item.FileName + ' isimli dosya yüklenemedi: ' + x.data.ErrorMessages;
                        this.$emit('onerror', this.error);
                    }
                    this.$forceUpdate();
                }).catch(x => {
                    item.State = signStatus.error;
                    item.OK = false;
                    this.setLoading(false);
                    this.error = item.FileName + ' isimli dosya yüklenemedi: ' + x;
                    this.$emit('onerror', this.error);
                });
            }
        },
        signDocument(item) {
            // Parametre olarak verilen dosyayı imzala

            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = 'İşlem iptal edildi.';
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                return;
            }

            if(this.error)
                return;

            this.setLoading(true);



            if(item.ContentForSign) {   // Eğer imzalanacak değer doğrudan item.ContentForSign içinde sağlanmış ise direk onu imzalıyoruz.
                this.signAtToken(item)
            } else {
                // item içinde içerik sağlanmamış ise item.GetUrl adresinden imzalanacak içeriği indiriyoruz.
                item.State = signStatus.prepearing;
                this.$forceUpdate();

                axios.get(item.GetUrl + '&certificateNumber=' + this.SelectedCert.CertificateSerialNumber)      // Dosyayı indir
                    .then(x => {
                        if(x.data.Success) {
                            item.SigningFunction = x.data.Data.SigningFunction;
                            item.SigningTime = x.data.Data.SigningTime;
                            item.TransactionId = x.data.Data.TransactionId;
                            item.ContentForSign = x.data.Data.ContentForSign;
                            this.signAtToken(item); // İmzalamak için tokena gönder
                        } else {
                            this.error = x.data.ErrorMessages;
                            this.setLoading(false);
                        }
                    })
                    .catch(x => {
                        item.OK = false;
                        item.State = signStatus.error;
                        this.error = 'Doküman indirilirken hata oluştu: ' + x;
                        this.setLoading(false);
                        this.$emit('onerror', this.error);
                        this.$forceUpdate();
                    });
            }
        },
        sign(){
            // Tüm dosyaları sırayla imzala
            // 1 - Sunucudan veriyi indir
            // 2 - Token üzerinde imzalama gerçekleştir
            // 3 - İmzalanan veriyi sunucuya gönder
            // 4 - Bir sonraki dosya için aynı süreci başlat
            // 4 - Tüm dosyaların imzalanması tamamlandığında dosyaları kabul işlemini çağır

            if(!this.PIN) {
                alert('E-imza şifrenizi giriniz.');
                this.$refs.pin.focus();
                return false;
            }

            if(!this.items || this.items.length == 0) {
                alert('İmzalanacak doküman yok.');
                return false;
            }

            this.setLoading(true);
            this.error = null;
            this.canceled = false;
            this.currentDocumentIndex = 0;

            this.items.forEach(x => {
                x.State = null;
                x.OK = false;
            });

            var doc = this.items[this.currentDocumentIndex];    // İlk dosyayı al
            this.signDocument(doc); // ve imzalamayı başlat
            return true;
        }
    }
}
</script>

<style scoped>
    .checking {
        color: color('gray-600');
        text-align:center;
        vertical-align: middle;
        height: 500px;
    }

    .terminal {
        padding:8px 10px;
        background-color: #EDEDED;
    }

    .cert-list {
        height:300px;
        overflow-y:auto;
        padding:0;
    }



    #pin {
        text-align: center;
    }

    .item-list {
        border:1px solid #E0E0E0;
        height:200px;
        overflow-y: scroll;
    }
</style>
